import { render, staticRenderFns } from "./OrdersWarnings.vue?vue&type=template&id=ef527340"
import script from "./OrdersWarnings.vue?vue&type=script&lang=js"
export * from "./OrdersWarnings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports